import { Grid, Typography } from "@mui/material";

import DatePicker from "components/DatePicker";
import React from "react";
import Select from "components/Select";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function InvestmentPortfolioFilters() {
  const [searchParams, setSearchParams] = useSearchParams();

  const investmentForm = useSelector(
    (state) => state.investment.investmentHistoryForm?.data
  );

  const defaultValues = {
    portfolioId:
      +searchParams.get("portfolioId") || investmentForm?.portfolioId,
    endDateInvestmentEnd:
      searchParams.get("endDateInvestmentEnd") ||
      "",
    endDateInvestmentStart:
      searchParams.get("endDateInvestmentStart") ||
      "",
    startDateInvestmentEnd:
      searchParams.get("startDateInvestmentEnd") ||
      "",
    startDateInvestmentStart:
      searchParams.get("startDateInvestmentStart") ||
      "",
  };

  const { watch, setValue } = useForm({ defaultValues });

  const handleChange = (value, fieldName) => {
    setValue(fieldName, value);
    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      page: 1,
      [fieldName]: value,
    });
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          صندق سرمایه گذاری
        </Typography>

        <Select
          items={investmentForm?.lisPortfolio}
          itemText="name"
          itemValue="id"
          value={watch("portfolioId")}
          onChange={(e) => handleChange(e.target.value, "portfolioId")}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          End Date Investment Start
        </Typography>

        <DatePicker
          value={watch("endDateInvestmentStart")}
          onChange={(e) => handleChange(e, "endDateInvestmentStart")}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          End Date Investment End
        </Typography>

        <DatePicker
          value={watch("endDateInvestmentEnd")}
          onChange={(e) => handleChange(e, "endDateInvestmentEnd")}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Start Date Investment Start
        </Typography>

        <DatePicker
          value={watch("startDateInvestmentStart")}
          onChange={(e) => handleChange(e, "startDateInvestmentStart")}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography variant="label" color="text.secondary">
          Start Date Investment End
        </Typography>

        <DatePicker
          value={watch("startDateInvestmentEnd")}
          onChange={(e) => handleChange(e, "startDateInvestmentEnd")}
        />
      </Grid>
    </Grid>
  );
}

export default InvestmentPortfolioFilters;
